const openLink = (url: string) => {
    window.open(url, "_blank", "noopener,noreferrer")
}

export default openLink
